import React from "react";
import TrackButton from "../TrackButton/index.jsx";

const TrackList = ({ tracks, onTrackClick, activeTrack }) => {
  const trackIds = Object.keys(tracks);

  return (
    <React.Fragment>
      {trackIds.map(id => {
        const track = tracks[id];
        return (
          <TrackButton
            key={id}
            isActive={id == activeTrack}
            keyColor={track.keyColor}
            onClick={onTrackClick(id)}
          >
            {track.title}
          </TrackButton>
        );
      })}
    </React.Fragment>
  );
};

export default TrackList;
